import React from 'react';
import { Grid, Typography, Link } from "@material-ui/core";
import '../../App.css'
import {ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import { Link as RouterLink } from 'react-router-dom';
import solutionsClasses from './solutionsStyles.js';



function OurSolutionsStudy() {
  const globalClasses = globalUseStyles();
  const solutionsStyles = solutionsClasses();

  return (
    <ThemeProvider theme={theme}>
      <Container className={"solutionsStudyStyle"} maxWidth={false} component="section">
          <Grid className={globalClasses.containerSmall} container >
            <Grid container >
                <Grid item xs={12} md={6} container>
                  <Grid item xs={12} md={12} className={solutionsStyles.rciImg} />
                </Grid>
                <Grid item xs={12} md={6} className={globalClasses.cardStyle}>
                  <Typography variant="subtitle1" >Featured Case Study</Typography>
                  <Typography variant="h3" >The Rosalyn Carter Institute for Caregivers (RCI)</Typography>
                  <Typography variant="body1" >RCI has been collecting wealth of data on caregivers in paper forms and assessments but has never had a technology solution that could collect such data electronically, aggregate the information, and provide business analytics to drive the direction of their organization and programming. </Typography>
                  <Typography variant="body1" >
                    <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                  </Typography>
                </Grid>
            </Grid>
          </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default OurSolutionsStudy;